import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ThemeToggle } from '../lib/ThemeToggle.js';
import { api } from '../lib/api.js';

export function CustomerLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') || '/customer';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await api.post('/api/customer/login', { email, password });
      navigate(next, { replace: true });
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="fixed top-4 right-4 z-10">
        <ThemeToggle />
      </div>
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-surface rounded-xl shadow-sm border border-neutral-200 p-8 space-y-4"
      >
        <header>
          <h1 className="text-xl font-semibold">고객사 로그인</h1>
          <p className="mt-1 text-sm text-neutral-600">aisight 라이선스 관리</p>
        </header>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-neutral-800 mb-1">
            이메일
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
            className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-400"
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-sm font-medium text-neutral-800 mb-1">
            비밀번호
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-400"
          />
        </div>

        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full px-4 py-2 bg-brand-400 hover:bg-brand-600 disabled:bg-neutral-300 text-white font-medium rounded-md"
        >
          {loading ? '로그인 중…' : '로그인'}
        </button>

        <footer className="pt-2 text-xs text-neutral-500 text-center">
          본사 직원이라면{' '}
          <Link to="/login" className="text-brand-600 hover:underline">
            관리자 로그인
          </Link>
        </footer>
      </form>
    </div>
  );
}
